import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
}
const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'default',
  size = 'default',
  ...props
}, ref) => {
  return <button ref={ref} className={cn('inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-slate-950 disabled:pointer-events-none disabled:opacity-50', {
    'bg-slate-900 text-slate-50 shadow hover:bg-slate-900/90': variant === 'default',
    'bg-red-500 text-slate-50 shadow-sm hover:bg-red-500/90': variant === 'destructive',
    'border border-slate-200 bg-white shadow-sm hover:bg-slate-100 hover:text-slate-900': variant === 'outline',
    'bg-slate-100 text-slate-900 shadow-sm hover:bg-slate-100/80': variant === 'secondary',
    'hover:bg-slate-100 hover:text-slate-900': variant === 'ghost',
    'text-slate-900 underline-offset-4 hover:underline': variant === 'link',
    'h-9 px-4 py-2': size === 'default',
    'h-8 rounded-md px-3 text-xs': size === 'sm',
    'h-10 rounded-md px-8': size === 'lg',
    'h-9 w-9': size === 'icon'
  }, className)} {...props} data-id="element-674" />;
});
Button.displayName = 'Button';
export { Button };